$(function(){

    var chart = $('#most_downloaded');
    var history = chart.data('history');
    var color = '#29fd2f';

    var ticks = $.map(history, function (elem, i) { return [[i, elem.label]] });
    var rawData = $.map(history, function (elem, i) { return [elem.data] });
    var dataSet = [{ label: "Mappe", data: rawData, color: color }];

    var max = _.max($.map(rawData, function(e) { return e }));
    //max += 5;
    $.plot(chart, dataSet, {
        series: {
            bars: {
                show: true
            }
        },
        bars: {
            align: "center",
            barWidth: 0.5,
            horizontal: true,
            fill: true,
            lineWidth: 1
        },
        legend: {
            show: false
        },
        xaxis: {
            axisLabel: "Numero Download",
            axisLabelUseCanvas: true,
            axisLabelPadding: 10,
            min: 0,
            max: max,
            tickDecimals: 0,
            tickColor: "#777777"
        },
        yaxis: {
            axisLabel: "Mappe",
            axisLabelUseCanvas: true,
            axisLabelPadding: 3,
            tickColor: "transparent",
            ticks: ticks
        },
        grid: {
            borderWidth: 0,
            labelMargin: 0,
            axisMargin: 0,
            minBorderMargin: 0
        }
    });

});